import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from 'seagull';
import ContactSupportButton from '~/components/ContactSupportButton';
import { useLocaleKeys } from '~/i18n';
import styles from '../ChangeEmailAddress.module.scss';
const ManyAttemptsError = (param)=>{
    let { onClose } = param;
    const { t: texts } = useLocaleKeys('components.changeEmailModal');
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "many-attempts-error",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: "error-message",
                        children: texts.tooManyAttempts()
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        children: [
                            texts.tryAgainLaterOr(),
                            " ",
                            /*#__PURE__*/ _jsx(ContactSupportButton, {
                                testId: "contact-support-button",
                                underline: "none"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.footer,
                children: /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'close_change_email_too_many_attempts'
                    },
                    onClick: onClose,
                    skin: "primaryOutline",
                    testId: "close-button",
                    children: texts.closeButton()
                })
            })
        ]
    });
};
export default ManyAttemptsError;
